import React from "react"

import ContentLines from "./content-loading/ContentLines"
import ListItemImageShadow from "./content-loading/ListItemImageShadow"

export default () => (
    // translate3d(0, 0, 0) is a workaround to force Chrome to perform re-layout
    <div className="list-group-item" style={{ transform: "translate3d(0, 0, 0)" }}>
        <ListItemImageShadow className="thumb-rounded" />
        <div className="list-group-item-content">
            <ContentLines minLineLength={30} />
            <ContentLines minLineLength={50} minLines={2} maxLines={3} />
        </div>
    </div>
)
